import { DomainRegistry as Base } from "../../base/domain";
import { ConfigurationRegistry } from "../../base/infrastructure/configuration";
import { ConfigurationRepository } from "../../base/infrastructure/configuration/ver2";
import { IConfiguration } from "./configuration";
import { IEditableFormatRegistry } from "./editableFormat";
import { IDeveloperRegistry } from "./developer";
import { IQuestionnaireRegistry } from "./questionnaire";
import { DefaultConfigurationOverwriter } from "../infrastructure/configuration";
import { EditableFormatRegistry } from "../infrastructure/editableFormat/ver2";
import { DeveloperRegistry } from "../infrastructure/developer/ver2";
import { QuestionnaireRegistry } from "../infrastructure/questionnaire/ver2";

export class DomainRegistry extends Base<IConfiguration> {
  // シングルトンインスタンス.
  static readonly instance: DomainRegistry = new DomainRegistry();

  constructor() {
    super();
    this._configuration = new ConfigurationRegistry(new ConfigurationRepository(DefaultConfigurationOverwriter.overwrite));
    this.editableFormat = new EditableFormatRegistry(this.getToken, this._configuration);
    this.formatEditorDeveloper = new DeveloperRegistry(this.getToken, this._configuration);
    this.questionnaire = new QuestionnaireRegistry(this.getToken);
  }

  public readonly editableFormat: IEditableFormatRegistry;
  public readonly formatEditorDeveloper: IDeveloperRegistry;
  public readonly questionnaire: IQuestionnaireRegistry;
}
